import { render, staticRenderFns } from "./maintenance-modal.vue?vue&type=template&id=5040687a&"
import script from "./maintenance-modal.vue?vue&type=script&lang=js&"
export * from "./maintenance-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports